const CALENDLY_CSS = 'https://assets.calendly.com/assets/external/widget.css';
const CALENDLY_JS = 'https://assets.calendly.com/assets/external/widget.js';

let loaded = false;
let loading = false;
const queue: Array<() => void> = [];

function loadCalendly(callback: () => void): void {
  if (loaded) {
    callback();
    return;
  }

  queue.push(callback);

  if (loading) return;
  loading = true;

  const css = document.createElement('link');
  css.rel = 'stylesheet';
  css.href = CALENDLY_CSS;
  document.head.appendChild(css);

  const script = document.createElement('script');
  script.src = CALENDLY_JS;
  script.onload = () => {
    loaded = true;
    queue.forEach((fn) => fn());
    queue.length = 0;
  };
  document.head.appendChild(script);
}

export function initCalendly(): void {
  document.addEventListener('click', (e: MouseEvent) => {
    const target = (e.target as Element).closest('[data-calendly]');
    if (!target) return;

    e.preventDefault();
    const url = (target as HTMLElement).dataset.calendly ?? '';
    if (!url) return;

    loadCalendly(() => {
      (window as any).Calendly.initPopupWidget({ url });
    });
  });
}
